import { combineReducers } from "@reduxjs/toolkit";
import applicationStateReducer from "../slices/applicationState/slice";
import deviceReducer from "../slices/device/slice";
import datesReducer from "../slices/dates/slice";
import surveyReducer from "../../modules/survey/infrastructure/store/slice/survey.slice";
import spaceReducer from "../../modules/spaces/infrastructure/store/slice/space.slice";
import { reducer as authReducer } from "../slices/auth/slice";
import modalReducer from "../slices/modal/slice";
import roomsReducer from "../slices/rooms/slice";
import filtersReducer from "../slices/filters/slice";
import environmentReducer from "../slices/environment/slice";

const reducers = {
  applicationState: applicationStateReducer,
  deviceState: deviceReducer,
  dateSelectorState: datesReducer,
  authState: authReducer,
  surveyState: surveyReducer,
  spaceState: spaceReducer,
  roomsState: roomsReducer,
  modalState: modalReducer,
  filtersSelectorState: filtersReducer,
  environmentState: environmentReducer,
};

export const combinedReducers = combineReducers(reducers);
